__turbopack_context__.v({
  "buttonLink": "styles-module-scss-module__Af1thG__buttonLink",
  "closeButton": "styles-module-scss-module__Af1thG__closeButton",
  "content": "styles-module-scss-module__Af1thG__content",
  "cta": "styles-module-scss-module__Af1thG__cta",
  "modal": "styles-module-scss-module__Af1thG__modal",
  "shake": "styles-module-scss-module__Af1thG__shake",
  "subtitle": "styles-module-scss-module__Af1thG__subtitle",
});
